<template lang="pug">
.items
    loading(:active="(products && products.loading) || loading" :is-full-page="false" :height="40" :width="40" color="#000")
    .item(
        v-for="product in items"
        :class="{'is-active': currentProduct && product.id === currentProduct.id}"
    )
        Matrix(:product="product")
    Pagination(
        v-if="pageInfo && pageInfo.lastPage > 1"
        :last-page="pageInfo.lastPage"
        :current-page="pageInfo.currentPage"
        nav-class="pagination is-small is-rounded is-centered"
        @change="changePage"
        nextLinkClass="is-rounded pagination-next is-circle is-right"
        prevLinkClass="is-rounded pagination-previous is-circle is-left"
    )
        span.icon(slot="prev")
            i.fas.fa-arrow-left
        span.icon(slot="next")
            i.fas.fa-arrow-right
</template>

<script>
import { mapGetters, mapMutations, mapActions } from 'vuex'
import get from 'lodash/get'

import Loading from 'vue-loading-overlay'

import Matrix from './Partials/Matrix'
import Pagination from '@/components/Pagination'

export default {
    name: 'ArticleList',
    props: {
        section: {
            type: Object,
            required: true,
        },
    },
    data() {
        return {
            loading: false,
            currentPage: 1,
        }
    },
    components: {
        Matrix,
        Loading,
        Pagination
    },
    computed: {
        pageInfo() {
            return get(this.products, 'pageInfo')
        },
        items() {
            return get(this.products, 'items', [])
        },
        currentProduct() {
            if (this.focusedMedia && this.focusedMedia.product) return this.focusedMedia.product
            return this.activeProduct
        },
        ...mapGetters({
            products: 'shop/products',
            sections: 'currentPage/sections',
            parent: 'currentPage/parent',
            menus: 'menus',
            member: 'auth/member',
            activeProduct: 'shop/activeProduct',
            focusedMedia: 'shop/focusedMedia',
            cms: 'CMS',
        }),
    },
    methods: {
        changePage(currentPage) {
            this.clearVisibleProducts()
            this.removeFocusedMedia()

            this.currentPage = currentPage
            this.refetch()
            window.scrollTo(0, 0)
        },
        refetch() {
            this.loading = true

            const shop = this.cms.shop.id
            let categories = []

            let c = get(this.section, 'shopCategories')
            if (c) categories = c.map(category => category.id)

            const payload = {
                pageInfo: {
                    currentPage: this.currentPage,
                    perPage: 6
                },
                filters: [
                    {
                        key: 'shop',
                        match: shop.toString()
                    },
                    {
                        key: 'status',
                        match: 'enabled'
                    },
                    {
                        key: 'categories',
                        in: categories
                    }
                ],
                order: 'property:groupsort',
                direction: 'asc'
            }
            this.fetchProducts(payload)
                .then(products => {
                    const container = document.querySelector('.preorder-columns > .column.left > .ps')
                    if (container) container.scrollTop = 0

                    this.insertProducts({ products })
                    this.loading = false
                })
        },
        ...mapMutations({
            // updateTeasersLoading: 'updateCategoryPostTeasersLoading',
            insertProducts: 'shop/insertProducts',
            changeActiveProduct: 'shop/setActiveProduct',
            clearVisibleProducts: 'shop/clearVisibleProducts',
            removeFocusedMedia: 'shop/removeFocusedMedia'
        }),
        ...mapActions({
            fetchProducts: 'shop/fetchProductsPaginated',
            // saveCartLocal: 'shop/saveCartLocal',
            // purchase: 'shop/createPurchase',
            fetchAuthenticatedMember: 'auth/fetchAuthenticatedMember'
        }),
    },
    mounted() {
        const products = { loading: true, pagination: {} }
        this.insertProducts({ products })

        this.currentPage = 1
        this.refetch()
    }
}

</script>
<style lang="sass">
    .items
        position: relative
        min-height: 200px
    .spacer
        height: 50px
    .item + .item
        margin-top: 6rem
    .item.is-active .arrow-container
        opacity: 1
    .pagination-container
        margin-top: 50px
</style>
